module.exports = function() { return __webpack_public_path__ + "when-traveling@2x.mThyzZmwDorIxB35gy3r.png";};